import { createLoadingScreen } from "../DomUtilities/ElementsCreator";
import openErrorModal from "../Error/ErrorModal";
import { deleteService, fetchDeleteServiceModal } from "../HTTPRequests/ServiceRequests";
import Mediator from "../Utilities/Mediator";

export default class DeleteServiceModal {
	loadingScreen: HTMLElement;
	serviceId: string;
	editModalDiv: HTMLDivElement;

	constructor(serviceId: string, editModal: HTMLDivElement) {
		this.loadingScreen = createLoadingScreen();
		this.serviceId = serviceId;
		this.editModalDiv = editModal;
	}

	public addDeleteModalClickListener() {
		const deleteButton: HTMLButtonElement = document.querySelector('#update-service-modal button');
		deleteButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchDeleteModal();
		}
	}

	private fetchDeleteModal() {
		fetchDeleteServiceModal(this.serviceId)
			.then((response: string) => {
				this.openDeleteModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	public openDeleteModal(modalHTMLString: string) {
		const modalDiv: HTMLDivElement = document.createElement("div");
		modalDiv.innerHTML = modalHTMLString;
		document.body.appendChild(modalDiv);

		const cancelButton: HTMLButtonElement = document.querySelector('#cancel');
		cancelButton.onclick = () => {
			modalDiv.remove();
		};

		const image: HTMLImageElement = document.querySelector('#delete-service-modal img[alt="close icon"]');
		image.onclick = () => {
			modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#delete-service-modal button:last-child');
		saveButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.deleteService(modalDiv);
		}
	}

	private deleteService(modalDiv: HTMLDivElement) {
		deleteService(this.serviceId)
			.then(() => {
				modalDiv.remove();
				this.editModalDiv.remove();
				Mediator.emit("serviceCrudOperationFinished");
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
